import React from "react";

//Dashboard
import Dashboard from "../pages/Dashboard";

import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

// //login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Register from "../pages/Authentication/Register";

// // User Profile
import Quotes from "pages/Quotes";
import Invoices from "pages/Invoices";
import Clients from "pages/Clients";
import Payments from "pages/Payments";
import RecordPayment from "pages/Payments/RecordPayment";
import ViewPayment from "pages/Payments/ViewPayment";
import PresetQuotes from "pages/PresetQuotes";
import Settings from "pages/Settings";
import ClientDetails from "pages/ClientDetails";
import ProfileSetup from "pages/Authentication/ProfileSetup";
import BusinessProfileSetup from "pages/Authentication/BusinessProfileSetup";
import BusinessAddress from "pages/Authentication/BusinessAddress";
import Subscription from "pages/Settings/Cards/Subscription";
import QuoteDetails from "pages/Quotes/QuoteDetails";
import ManageQuotes from "pages/ManageQuotes";
import Profile from "pages/Settings/Cards/Profile";
import InvoiceDetails from "pages/Invoices/InvoiceDetails";
import PaymentsAndInvoicing from "pages/Settings/Cards/PaymentsAndInvoicing";
import ChangePassword from "pages/Settings/Cards/ChangePassword";
import NotificationsPreference from "pages/Settings/Cards/NotificationsPreference";
import TeamMembers from "pages/Settings/Cards/TeamMembers";
import Notifications from "pages/NotificationList/Notifications";
import Categories from "pages/Settings/Cards/Categories";
import SubCategories from "pages/Settings/Cards/SubCategories";
import Items from "pages/Settings/Cards/Items";
import SubscriptionPlan from "pages/SubscriptionPlan";
import ManagePresetQuotes from "pages/ManagePresetQuotes";
import ManageInvoices from "pages/ManageInvoices";
import Sections from "pages/Settings/Cards/Sections";
import PresetQuoteDetail from "pages/PresetQuotesDetails";
import ProfileCompleteProtected from "./ProfileCompleteProtected";
import Users from "pages/Users";
import UserDetail from "pages/Users/UserDetail";
import AdminDashboard from "pages/Dashboard/AdminDashboard";
import { Navigate } from "react-router-dom";
import ViewQuote from "pages/view/ViewQuote";
import ViewInvoice from "pages/view/ViewInvoice";
import ViewStatus from "pages/view/ViewStatus";
import PayDeposit from "pages/view/PayDeposit";
import DepositPaySuccess from "pages/view/DepositPaySuccess";
import PaymentCheckout from "pages/view/PaymentCheckout";

// User only routes (for regular users)
const userProtectedRoutes = [
  // dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/notifications-list", component: <Notifications /> },

  // quotes
  { path: "/quotes", component: <Quotes /> },
  { path: "/quote-details", component: <QuoteDetails /> },

  // invoices
  { path: "/invoices", component: <Invoices /> },
  { path: "/invoice-details", component: <InvoiceDetails /> },

  // clients
  { path: "/clients", component: <Clients /> },
  { path: "/client-details", component: <ClientDetails /> },

  // payments
  { path: "/payments", component: <Payments /> },
  { path: "/record-payment", component: <RecordPayment /> },
  { path: "/view-payment", component: <ViewPayment /> },
  {
    path: "/manage-invoice",
    component: (
      <ProfileCompleteProtected>
        <ManageInvoices />
      </ProfileCompleteProtected>
    ),
  },

  { path: "/preset-quotes", component: <PresetQuotes /> },
  { path: "/manage-preset-quotes", component: <ManagePresetQuotes /> },
  { path: "/preset-quotes-details", component: <PresetQuoteDetail /> },
  {
    path: "/manage-quotes",
    component: (
      <ProfileCompleteProtected>
        <ManageQuotes />
      </ProfileCompleteProtected>
    ),
  },
  { path: "/settings", component: <Settings /> },
  { path: "/sections", component: <Sections /> },
  { path: "/index", component: <Dashboard /> },

  //Sub Settings pages
  { path: "/subscription", component: <Subscription /> },
  { path: "/profile", component: <Profile /> },
  { path: "/payments-and-invoicing", component: <PaymentsAndInvoicing /> },
  { path: "/change-password", component: <ChangePassword /> },
  { path: "/notifications-preference", component: <NotificationsPreference /> },
  { path: "/team-members", component: <TeamMembers /> },
  { path: "/categories", component: <Categories /> },
  { path: "/subcategories", component: <SubCategories /> },
  { path: "/items", component: <Items /> },
  { path: "/subscribe-plan", component: <SubscriptionPlan /> },

  // Role-based redirect routes (should be at the end)
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

// Admin only routes (same URLs but different components for admin)
const adminProtectedRoutes = [
  { path: "/dashboard", component: <AdminDashboard /> },
  { path: "/users", component: <Users /> },
  { path: "/user-detail", component: <UserDetail /> },
  { path: "/settings", component: <ChangePassword /> },

  // Role-based redirect routes (should be at the end)
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //Email Quote/Invoice View Page (Public - no auth required)
  { path: "/view-quote", component: <ViewQuote /> },
  { path: "/view-invoice", component: <ViewInvoice /> },
  { path: "/status-quote-invoice", component: <ViewStatus /> },
  { path: "/pay-deposit", component: <PayDeposit /> },
  { path: "/payment-checkout", component: <PaymentCheckout /> },
  { path: "/deposit-success", component: <DepositPaySuccess /> },

  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/auth-offline", component: <Offlinepage /> },
];

const onboardingRoutes = [
  //Profile Setup
  { path: "/profile-setup", component: <ProfileSetup /> },
  { path: "/business-profile-setup", component: <BusinessProfileSetup /> },
  { path: "/business-address", component: <BusinessAddress /> },
];

export {
  publicRoutes,
  onboardingRoutes,
  adminProtectedRoutes,
  userProtectedRoutes,
};
